import store from "@/store";
import router from "@/router";
import nativeHandlerService from "@/services/nativeHandler";

export const goToExternalApp = async (park) => {
  if (store.getters["common/device"] == "BROWSER") {
    alert("アプリへ park.Station.code :>> " + park.Station.code.split(".")[1]);
  } else {
    nativeHandlerService.ncDbsOfficialApp(park.Station.code.split(".")[1]);
  }
};
